import { css } from '@emotion/react';
import styled from '@emotion/styled';
import propTypes from '@styled-system/prop-types';
import { color, compose, layout, position, space } from 'styled-system';

import { forwardValidProp } from '../../utils/style';

const baseDividerStyles = ({ theme }) => css`
  border: 0.0625rem solid ${theme.colors.divider.background};
  width: 0.0625rem;
`;

const StyledDivider = styled('hr', {
  shouldForwardProp: (prop) => forwardValidProp(prop),
})`
  ${baseDividerStyles}
  ${compose(color, layout, position, space)}
`;

function Divider({ ...props }) {
  return <StyledDivider {...props} />;
}

Divider.propTypes = {
  /**
   * Implements `styled-system` [space](https://styled-system.com/api/#space) utility
   */
  ...propTypes.space,
  /**
   * Implements `styled-system` [layout](https://styled-system.com/api/#layout) utility
   */
  ...propTypes.layout,
  /**
   * Implements `styled-system` [position](https://styled-system.com/api/#position) utility
   */
  ...propTypes.position,
};

export default Divider;
